import React, { useEffect } from "react";

import { CSelect } from "@coreui/react";
import PropTypes from "prop-types";

export function ListSelect({
  handleSelectedValue,
  items,
  selectDomID,
  itemNameKeyIs,
  disabled,
  selectedValue,
  multiple,
  sorted,
  itemIdKeyIs,
  defaultItemName,
  height,
  "data-testid": dataTestId,
}) {
  const [selected, setSelected] = React.useState(null);

  useEffect(() => {
    setSelected(selectedValue);
  }, [selectedValue]);
  // Handle Selected will fire when an item is selected
  // items should be an array of objects with id and itemNameKeyIs properties
  const handleChange = (event) => {
    event.preventDefault();
    if (multiple) {
      const arr = Array.from(event.target.options)
        .filter((o) => o.selected)
        .map((o) => o.value);
      setSelected(arr);
      handleSelectedValue(arr);
    } else {
      setSelected(event.target.value);
      handleSelectedValue(event.target.value);
    }
  };

  let displayItems = items;
  if (sorted && displayItems !== undefined) {
    displayItems = JSON.parse(JSON.stringify(items)); // deep clone
    displayItems.sort((a, b) => (a[itemNameKeyIs] > b[itemNameKeyIs] ? 1 : -1));
  }

  return (
    <CSelect
      onChange={handleChange}
      id={selectDomID}
      data-testid={dataTestId}
      disabled={disabled}
      value={selected ? selected : ""}
      multiple={multiple}
      style={{ height: height, maxHeight: "25vh" }}
    >
      {!multiple && <option value={""}>{defaultItemName}</option>}
      {displayItems?.map((item, idx) => (
        <option key={idx} value={item[itemIdKeyIs]}>
          {item[itemNameKeyIs]}
        </option>
      ))}
    </CSelect>
  );
}

ListSelect.propTypes = {
  handleSelectedValue: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
  selectDomID: PropTypes.string.isRequired,
  itemNameKeyIs: PropTypes.string,
  disabled: PropTypes.bool,
  selectedValue: PropTypes.any,
  multiple: PropTypes.bool,
  sorted: PropTypes.bool,
  itemIdKeyIs: PropTypes.string,
  height: PropTypes.string,
  defaultItemName: PropTypes.string,
  "data-testid": PropTypes.string,
};

ListSelect.defaultProps = {
  itemNameKeyIs: "name",
  disabled: false,
  multiple: false,
  sorted: true,
  itemIdKeyIs: "id",
  defaultItemName: "Select One...",
};
